import { hidePrices as savePricesHidden, showPrices as savePricesShown } from "@/services/user/settings/pricesHiding";
import * as PostHog from "@/services/analytics/postHog";
import { useUser } from "@/composables/user/user";

const arePricesVisible = ref<boolean>(true);

export function usePriceVisibility() {
  const { user } = useUser();

  const hidePrices = () => {
    if (user.value === undefined) {
      throw new Error("DEV: User not logged in.");
    }
    user.value.showPrices = false;
    arePricesVisible.value = false;
    savePricesHidden(); // Save settings in BE.
    PostHog.trackEvent(PostHog.EventName.ShowPricesSettingsChange);
  };

  const showPrices = () => {
    if (user.value === undefined) {
      throw new Error("DEV: User not logged in.");
    }
    arePricesVisible.value = true;
    user.value.showPrices = false;
    savePricesShown(); // Save settings in BE.
    PostHog.trackEvent(PostHog.EventName.ShowPricesSettingsChange);
  };

  return {
    hidePrices,
    showPrices,
    arePricesVisible,
  };
}
